// OverlayMessage.tsx
import React from 'react';
import { Typography } from '@material-ui/core';

interface OverlayMessageProps {
  message: string;
  onClose?: () => void;
}

export const OverlayMessage: React.FC<OverlayMessageProps> = ({ message }) => {
  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        background: 'rgba(0,0,0,0.4)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 2000,
      }}
    >
      <div
        style={{
          maxWidth: '500px',
          padding: '24px',
          background: '#02486B',
          color: '#fff',
          borderRadius: '8px',
          textAlign: 'center',
          fontSize: '18px',
          boxShadow: '0 4px 16px rgba(0,0,0,0.3)',
        }}
      >
        <Typography style={{ color: 'white', fontSize: '18px', lineHeight: 1.4 }}>{message}</Typography>
      </div>
    </div>
  );
};
